import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import {
  AirlineStops as AirlineStopsIcon,
  MailOutline as MailOutlineIcon,
  Mouse as MouseIcon,
  PeopleAltOutlined as PeopleAltOutlinedIcon,
  Unsubscribe as UnsubscribeIcon,
} from '@mui/icons-material';

import { campaignsSelectors } from 'store/selectors/campaigns';

import { StatisticTiles } from 'common/components';

import { colors } from 'utils/constants';
import { CardWrapper } from 'globalStyles';

const StatisticWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 40px;
`;

const Title = styled.h2`
  margin-bottom: 20px;
  font-weight: 400;
  font-size: 20px;
`;

const ActionAlertOverview = () => {
  const { actionAlertDetails } = useSelector(state => ({
    actionAlertDetails: campaignsSelectors.getActionAlertDetails(state),
  }));

  const { statistics } = actionAlertDetails;

  const tiles = useMemo(
    () => [
      {
        count: statistics?.recipients,
        icon: (
          <PeopleAltOutlinedIcon
            color="blue"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.people,
        name: 'Recipients',
      },
      {
        count: statistics?.opened,
        icon: (
          <MailOutlineIcon
            color="green"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.greenBackground,
        name: 'Opened',
      },
      {
        count: statistics?.clicked,
        icon: (
          <MouseIcon
            color="yellow"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.yellowBackground,
        name: 'Clicked',
      },
      {
        count: statistics?.bounced,
        icon: (
          <AirlineStopsIcon
            color="green"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.greenBackground,
        name: 'Bounced',
      },
      {
        count: statistics?.unsubscribed,
        icon: (
          <UnsubscribeIcon
            color="error"
            sx={{
              fontSize: 16,
            }}
          />
        ),
        iconColor: colors.errorBackground,
        name: 'Unsubscribed',
      },
    ],
    [
      statistics?.recipients,
      statistics?.opened,
      statistics?.clicked,
      statistics?.bounced,
      statistics?.unsubscribed,
    ]
  );

  return (
    <CardWrapper>
      <Title>Overview</Title>
      <StatisticWrapper>
        <StatisticTiles tiles={tiles} />
      </StatisticWrapper>
    </CardWrapper>
  );
};

export default ActionAlertOverview;
